'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _filter = require('constructicon/filter');

var _filter2 = _interopRequireDefault(_filter);

var _leaderboard = require('constructicon/leaderboard');

var _leaderboard2 = _interopRequireDefault(_leaderboard);

var _leaderboardItem = require('constructicon/leaderboard-item');

var _leaderboardItem2 = _interopRequireDefault(_leaderboardItem);

var _fitnessLeaderboard = require('../../api/fitness-leaderboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FitnessLeaderboard = function (_Component) {
  _inherits(FitnessLeaderboard, _Component);

  function FitnessLeaderboard() {
    _classCallCheck(this, FitnessLeaderboard);

    var _this = _possibleConstructorReturn(this, (FitnessLeaderboard.__proto__ || Object.getPrototypeOf(FitnessLeaderboard)).call(this));

    _this.fetchLeaderboard = _this.fetchLeaderboard.bind(_this);
    _this.setFilter = _this.setFilter.bind(_this);
    _this.renderLeader = _this.renderLeader.bind(_this);
    _this.state = {
      status: 'fetching',
      q: null
    };
    return _this;
  }

  _createClass(FitnessLeaderboard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var refreshInterval = this.props.refreshInterval;

      this.fetchLeaderboard();
      this.interval = refreshInterval && setInterval(function () {
        return _this2.fetchLeaderboard(_this2.state.q, true);
      }, refreshInterval);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props !== prevProps) {
        this.fetchLeaderboard(this.state.q);
      }
    }
  }, {
    key: 'setFilter',
    value: function setFilter(q) {
      this.setState({ q: q });
      this.fetchLeaderboard(q);
    }
  }, {
    key: 'fetchLeaderboard',
    value: function fetchLeaderboard(q, refresh) {
      var _this3 = this;

      var _props = this.props,
          activity = _props.activity,
          campaign = _props.campaign,
          charity = _props.charity,
          country = _props.country,
          type = _props.type,
          group = _props.group,
          startDate = _props.startDate,
          endDate = _props.endDate,
          includeManual = _props.includeManual,
          excludeVirtual = _props.excludeVirtual,
          excludePageIds = _props.excludePageIds,
          limit = _props.limit,
          page = _props.page,
          groupID = _props.groupID,
          sortBy = _props.sortBy;


      !refresh && this.setState({
        status: 'fetching',
        data: undefined
      });

      (0, _fitnessLeaderboard.fetchFitnessLeaderboard)({
        activity: activity,
        campaign: campaign,
        charity: charity,
        country: country,
        type: type,
        group: group,
        startDate: startDate,
        endDate: endDate,
        include_manual: includeManual,
        exclude_virtual: excludeVirtual,
        limit: limit + 10,
        page: page,
        groupID: groupID,
        sortBy: sortBy,
        q: q
      }).then(function (data) {
        return data.map(_fitnessLeaderboard.deserializeFitnessLeaderboard);
      }).then(function (data) {
        return _this3.removeExcludedPages(excludePageIds, data);
      }).then(function (data) {
        return data.slice(0, limit);
      }).then(function (data) {
        _this3.setState({
          status: 'fetched',
          data: data
        });
      }).catch(function (error) {
        _this3.setState({
          status: 'failed'
        });
        return Promise.reject(error);
      });
    }
  }, {
    key: 'removeExcludedPages',
    value: function removeExcludedPages(excludePageIds, pages) {
      return excludePageIds ? pages.filter(function (page) {
        return excludePageIds.split(',').indexOf(page.id.toString()) === -1;
      }) : pages;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          status = _state.status,
          _state$data = _state.data,
          data = _state$data === undefined ? [] : _state$data;
      var _props2 = this.props,
          leaderboard = _props2.leaderboard,
          filter = _props2.filter;


      return _react2.default.createElement(
        'div',
        null,
        filter && _react2.default.createElement(_filter2.default, _extends({ onChange: this.setFilter }, filter)),
        _react2.default.createElement(_leaderboard2.default, _extends({
          loading: status === 'fetching',
          error: status === 'failed',
          children: data.map(this.renderLeader)
        }, leaderboard))
      );
    }
  }, {
    key: 'renderLeader',
    value: function renderLeader(leader, i) {
      var _props$leaderboardIte = this.props.leaderboardItem,
          leaderboardItem = _props$leaderboardIte === undefined ? {} : _props$leaderboardIte;


      return _react2.default.createElement(_leaderboardItem2.default, _extends({
        key: i,
        title: leader.name,
        subtitle: leader.charity,
        image: leader.image,
        amount: this.getMetric(leader),
        href: leader.url
      }, leaderboardItem));
    }
  }, {
    key: 'getMetric',
    value: function getMetric(leader) {
      var _props3 = this.props,
          miles = _props3.miles,
          sortBy = _props3.sortBy;


      switch (sortBy) {
        case 'calories':
          return (0, _numbro2.default)(leader.calories).format('0,0') + ' cals';
        case 'duration':
          return (0, _numbro2.default)(leader.duration).format('0,0') + ' secs';
        case 'elevation':
          var elevation = miles ? leader.elevation * 3.28084 : leader.elevation;
          return (0, _numbro2.default)(elevation).format('0,0') + ' ' + (miles ? 'ft' : 'm');
        default:
          var distance = miles ? leader.distance / 1609.34 : leader.distance / 1000;
          return (0, _numbro2.default)(distance).format('0,0') + ' ' + (miles ? 'mi.' : 'kms');
      }
    }
  }]);

  return FitnessLeaderboard;
}(_react.Component);

FitnessLeaderboard.propTypes = {
  /**
   * The campaign uid to fetch pages for
   */
  campaign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * The charity uid to fetch pages for
   */
  charity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * The type of page to include in the leaderboard
   */
  type: _propTypes2.default.oneOf(['group', 'individual', 'team']),

  /**
   * The activity type of page to include in the leaderboard (bike, gym, hike, run, sport, swim, walk)
   */
  activity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * The group value(s) to filter by
   */
  group: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * Start date filter (ISO Format)
   */
  startDate: _propTypes2.default.string,

  /**
   * End date filter (ISO Format)
   */
  endDate: _propTypes2.default.string,

  /**
   * Include Virtual
   */
  includeVirtual: _propTypes2.default.bool,

  /**
   * Include Manual
   */
  includeManual: _propTypes2.default.bool,

  /**
   * Exclude Virtual
   */
  excludeVirtual: _propTypes2.default.bool,

  /**
   * Unit
   */
  miles: _propTypes2.default.bool,

  /**
   * The number of records to fetch
   */
  limit: _propTypes2.default.number,

  /**
   * The page to fetch
   */
  page: _propTypes2.default.number,

  /**
   * The group ID to group the leaderboard by (only relevant if type is group)
   */
  groupID: _propTypes2.default.number,

  /**
   * The type of measurement to sort by
   */
  sortBy: _propTypes2.default.oneOf(['distance', 'duration', 'calories', 'elevation']),

  /**
   * Props to be passed to the Constructicon Leaderboard component
   */
  leaderboard: _propTypes2.default.object,

  /**
   * Props to be passed to the Constructicon LeaderboardItem component
   */
  leaderboardItem: _propTypes2.default.object,

  /**
   * Props to be passed to the Filter component (false to hide)
   */
  filter: _propTypes2.default.any,

  /**
   * Interval (in milliseconds) to refresh data from API
   */
  refreshInterval: _propTypes2.default.number
};

FitnessLeaderboard.defaultProps = {
  limit: 10,
  page: 1,
  filter: {},
  sortBy: 'distance'
};

exports.default = FitnessLeaderboard;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/fitness-leaderboard/index.js
// module id = 1328
// module chunks = 0